<template>
    <div class="ui clearing segment">
        <button class="ui right floated button" @click="addRootItem">Add Root Item</button>
        <h4>Menus</h4>
        <div class="ui list">
            <admin-menu-tree-item v-for="item in menus" :key="item.id" :item="item" @selected="onSelected" :selected="selected"></admin-menu-tree-item>
        </div>
        <admin-menu-item-editor :item="selected" v-if="selected !== null" @cancel="onCancel" @save="onSave" @new-item="onNewItem" @delete="onDelete"></admin-menu-item-editor>
    </div>
</template>

<script>
import AdminMenuTreeItem from './AdminMenuTreeItem';
import AdminMenuItemEditor from './AdminMenuItemEditor';

export default {
  components: {
    AdminMenuItemEditor,
    AdminMenuTreeItem,
  },
  name: 'menus',

  created() {
    this.$store.dispatch('adminMenu/load');
  },

  methods: {
    onSelected(selection) {
      this.$store.commit('adminMenu/setSelected', selection);
    },

    onNewItem(item) {
      this.$store.commit('adminMenu/setSelected', item);
    },

    onSave(item) {
      this.$store.dispatch('adminMenu/save', item);
    },

    onCancel() {
      if (this.selected !== null && this.selected.id === undefined) {
        this.$store.commit('adminMenu/revert');
        this.$store.commit('adminMenu/setSelected', null);
      } else this.$store.commit('adminMenu/setSelected', null);
    },

    onDelete(item) {
      this.$refs.confModal.show().then((confirmed) => {
        if (confirmed) {
          if (item.id === undefined) {
            this.$store.commit('adminMenu/revert');
          } else {
            this.$store.dispatch('adminMenu/remove', item.id);
          }
        }
      });
    },

    addRootItem() {
      let itemTemplate = {
        active: false,
        display_name: '<new-item>',
        url: null,
        pageId: null,
        sort_index: 995,
        parentId: null,
      };

      this.$store.commit('adminMenu/appendNew', itemTemplate);
      this.onSelected(itemTemplate);
    },
  },

  computed: {
    menus() {
      return this.$store.state.adminMenu.menus;
    },

    selected() {
      return this.$store.state.adminMenu.selected;
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/Menus.vue